export default "__VITE_ASSET__wOy5GzZm__"